import LoyaltyEarlyAccessSaleBanner from "../../components/LoyaltyEarlyAccessSale/Banner";
import { useSelector } from "react-redux";
import { getCategoryId } from "../../state/modules/category";
import {
  getIsBenefitAvailable,
  getIsBenefitEventActive,
  getStoreCode
} from "../../state/modules/config/selectors";
import { EARLY_ACCESS_SALE } from "../../state/modules/config/constants";

const ConnectedLoyaltyEarlyAccessSaleBanner = props => {
  const categoryId = useSelector(getCategoryId);
  const isBenefitAvailable = useSelector(getIsBenefitAvailable);
  const isBenefitEventActive = useSelector(getIsBenefitEventActive);
  const storeCode = useSelector(getStoreCode);

  return (
    <LoyaltyEarlyAccessSaleBanner
      {...props}
      categoryId={categoryId}
      isEarlyAccessSaleAvailable={isBenefitAvailable?.[EARLY_ACCESS_SALE]}
      isEarlyAccessSaleEventActive={isBenefitEventActive?.[EARLY_ACCESS_SALE]}
      storeCode={storeCode}
    />
  );
};

export default ConnectedLoyaltyEarlyAccessSaleBanner;
